import { IHsf012Globals } from './typings';

declare global {
	interface Window {
		___hsf012_forms_globals: IHsf012Globals;
	}
}

export default window.___hsf012_forms_globals;
